import GenericActionBlock from './GenericActionBlock';
import { GenericActionBlockProps, GenericActionBlockValueProps } from './types';

export type { GenericActionBlockProps, GenericActionBlockValueProps };
export default GenericActionBlock;
